// Хуки для работы с формой Form1

import { useCallback, useEffect } from 'react';
import { resolveForestAddress } from '../../../utils/forestAddress';
import { parseDecimal } from '../../../utils/decimalUtils';
import { validateArea, validateLpArea, validateLength } from './utils';

// Хук для валидации формы
export const useFormValidation = (localFormData, setLocalFormData, handbooks = []) => {
  // Уведомляем родительский компонент о состоянии валидации
  useEffect(() => {
    if (setLocalFormData && localFormData) {
      const requiredFields = [
        'srf',          // Субъект РФ
        'filial',       // Организация, проводившая работу
        'lvo',          // Лесничество
        'ulvo',         // Участковое лесничество
        'kv',           // Квартал
        's',            // S лесотаксационного выдела, га (в состоянии формы — sga)
        'sga',          // S, га
        'lpvid',        // № лесопатологического выдела
        'slp',          // S лесопатологического выдела, га
        'cel',          // Цель ВНН
        'datar'         // Дата проведения ВНН
        // 'lmh' - Протяжённость маршрутного хода - необязательное поле
      ];
      
      const address = resolveForestAddress(localFormData, handbooks);
      if (address.isUrcRequired) requiredFields.push('urc');
      const emptyFields = requiredFields.filter(field => {
        const value = localFormData[field];
        // Раньше пустой lpvid не считался незаполненным, потому что на экране
        // вместо него рисовалась «1». Теперь ForestPathVydelSection записывает
        // эту единицу в данные, так что поле проверяется наравне с остальными.
        if (!value || value === '') return true;
        
        // Дополнительная проверка для числовых полей
        if (field === 'sga') {
          return !validateArea(value);
        }
        
        if (field === 'slp') {
          return !validateLpArea(value, parseDecimal(localFormData.sga) || 0);
        }
        
        // Поле 'lmh' необязательное, поэтому не проверяем его
        
        return false;
      });
      
      const hasErrors = emptyFields.length > 0 || !address.lvo || !address.ulvo || (address.isUrcRequired && !address.urc);
      
      // Обновляем только если состояние изменилось
      setLocalFormData(prev => {
        if (prev.form1ValidationErrors !== hasErrors) {
          return {
            ...prev,
            form1ValidationErrors: hasErrors
          };
        }
        return prev;
      });
    }
  }, [localFormData, setLocalFormData, handbooks]);
};

// Функция для очистки данных таблицы
export const useClearTableData = (localFormData, setLocalFormData, setFormData) => {
  const clearTableData = useCallback((tableType) => {
    if (tableType === 'location') {
      // Очищаем только данные местоположения (координаты и номер участка)
      const newData = {
        ...localFormData,
        lat: '',
        lon: '',
        vnum: ''
      };
      setLocalFormData(newData);
      if (setFormData) {
        setFormData(newData);
      }
    } else if (tableType === 'details') {
      // Очищаем данные сведений (включая субъект РФ и все зависимые поля)
      const newData = {
        ...localFormData,
        srf: '',
        filial: '',
        lvo: '',
        ulvo: '',
        urc: '',
        lvoId: '', ulvoId: '', urcId: '', isUrcRequired: false,
        kv: '',
        kadastr: '',
        s: '',
        sga: '',
        lpvid: '',
        slp: ''
      };
      setLocalFormData(newData);
      if (setFormData) {
        setFormData(newData);
      }
    } else if (tableType === 'info') {
      // Очищаем данные информации
      const newData = {
        ...localFormData,
        cel: '',
        // очищаем дату проведения ВНН; data — дата создания карточки, её не трогаем
        datar: '',
        ekolzona: '',
        nmh: '',
        lmh: '',
        itaks1: ''
      };
      setLocalFormData(newData);
      if (setFormData) {
        setFormData(newData);
      }
    }
  }, [localFormData, setLocalFormData, setFormData]);

  return clearTableData;
};

